(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamami-back-to-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mamami-back-to-buy')) {
    customElements.define('mamami-back-to-buy', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        this.button.addEventListener('click', () => {
          this.update();
          if (this.button.hidden || !this.target) return;
          this.target.focus({ preventScroll: true });
          this.area.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: 'center'
          });
        }, options);
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
          document.addEventListener(event, this.schedule, options);
        }
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(document.body);
        this.mutationObserver = new MutationObserver(this.schedule);
        this.mutationObserver.observe(document.body, {
          subtree: true, childList: true, attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'aria-hidden', 'hidden', 'open', 'class', 'style']
        });
        this.schedule();
      }

      update() {
        this.target = document.querySelector('[id^="MainProduct-"] .product-form__buttons button[id^="ProductSubmitButton-"][name="add"]');
        this.area = this.target?.closest('.product-form__buttons');
        const valid = this.target?.isConnected && !this.target.disabled &&
          this.target.getAttribute('aria-disabled') !== 'true' && this.target.getClientRects().length > 0;
        const modalVisible = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]:not([aria-hidden="true"])'))
          .some((modal) => {
            if (modal.closest('details:not([open]), [hidden], [aria-hidden="true"]')) return false;
            const bounds = modal.getBoundingClientRect();
            const style = getComputedStyle(modal);
            return bounds.width > 0 && bounds.height > 0 &&
              bounds.bottom > 0 && bounds.top < window.innerHeight &&
              bounds.right > 0 && bounds.left < window.innerWidth &&
              style.visibility === 'visible' && style.display !== 'none' && Number(style.opacity) > 0;
          });
        const mobileNavigationOpen = matchMedia('(max-width: 989px)').matches &&
          document.querySelector('header-drawer > details[open]');
        const hidden = document.querySelector('mamami-back-to-buy') !== this || !valid || modalVisible || mobileNavigationOpen ||
          !this.area || this.area.getBoundingClientRect().bottom >= 0;
        if (this.button.hidden !== Boolean(hidden)) this.button.hidden = Boolean(hidden);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.events = null;
        if (this.button) this.button.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamami-matcharella-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mamami-matcharella-motion')) {
    customElements.define('mamami-matcharella-motion', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motionQuery = matchMedia('(prefers-reduced-motion: no-preference)');
        this.pointerQuery = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
        this.reset = () => {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.style.removeProperty('--mmm-x');
          this.style.removeProperty('--mmm-y');
        };
        this.canTilt = () => this.dataset.animate === 'true' && this.motionQuery.matches && this.pointerQuery.matches;
        this.motionQuery.addEventListener('change', this.reset, options);
        this.pointerQuery.addEventListener('change', this.reset, options);
        this.addEventListener('pointerleave', this.reset, options);
        this.addEventListener('pointercancel', this.reset, options);
        this.addEventListener('pointermove', (event) => {
          if (!this.canTilt() || event.pointerType === 'touch') return;
          this.pointer = { x: event.clientX, y: event.clientY };
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            const rect = this.getBoundingClientRect();
            const x = Math.max(-1, Math.min(1, (this.pointer.x - rect.left) / rect.width * 2 - 1));
            const y = Math.max(-1, Math.min(1, (this.pointer.y - rect.top) / rect.height * 2 - 1));
            this.style.setProperty('--mmm-x', `${(-y * 1.5).toFixed(2)}deg`);
            this.style.setProperty('--mmm-y', `${(x * 2.5).toFixed(2)}deg`);
          });
        }, { ...options, passive: true });
        this.observer = new IntersectionObserver(([entry]) => {
          this.dataset.visible = String(entry.isIntersecting);
          if (!entry.isIntersecting) this.reset();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.reset?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamami-mid-autumn-light"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mamami-mid-autumn-light')) {
    const played = new Set();
    customElements.define('mamami-mid-autumn-light', class extends HTMLElement {
      restoreHeading() {
        if (!this.headingLines) return;
        this.headingLines.forEach(({ line, text }) => {
          line.textContent = text;
          line.removeAttribute('aria-hidden');
        });
        this.querySelector('.mal__title')?.removeAttribute('aria-label');
        this.classList.remove('has-character-reveal');
        this.headingLines = null;
      }
      prepareHeading(key) {
        if (this.headingLines) return;
        const title = this.querySelector('.mal__title');
        if (!title) return;
        const lines = [...title.querySelectorAll('.mal__heading-line')];
        this.headingLines = lines.map(line => ({ line, text: line.textContent }));
        try {
          const characters = [];
          const fragments = this.headingLines.map(({ text }) => {
            const fragment = document.createDocumentFragment();
            for (const token of text.split(/(\s+)/)) {
              if (!token) continue;
              if (/^\s+$/.test(token)) { fragment.append(document.createTextNode(token)); continue; }
              const word = document.createElement('span');
              word.className = 'mal__word';
              const letters = typeof Intl.Segmenter === 'function'
                ? [...new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(token)].map(item => item.segment)
                : Array.from(token);
              for (const letter of letters) {
                const character = document.createElement('span');
                character.className = 'mal__character';
                character.textContent = letter;
                characters.push(character);
                word.append(character);
              }
              fragment.append(word);
            }
            return fragment;
          });
          // Seeded Fisher-Yates across both lines; spaces never receive a delay.
          let seed = 2166136261;
          for (const letter of key + this.headingLines.map(item => item.text).join(' ')) {
            seed = Math.imul(seed ^ letter.charCodeAt(0), 16777619) >>> 0;
          }
          const shuffled = [...characters];
          for (let i = shuffled.length - 1; i > 0; i--) {
            seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
            const j = Math.floor(seed / 4294967296 * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
          }
          shuffled.forEach((character, rank) => character.style.setProperty('--mal-character-delay',
            (0.15 + 1.2 * rank / Math.max(1, shuffled.length - 1)).toFixed(4) + 's'));
          title.setAttribute('aria-label', this.headingLines.map(item => item.text).join(' '));
          lines.forEach((line, index) => {
            line.replaceChildren(fragments[index]);
            line.setAttribute('aria-hidden', 'true');
          });
          this.classList.add('has-character-reveal');
        } catch {
          this.restoreHeading();
          this.classList.add('heading-reveal-failed');
        }
      }
      connectedCallback() {
        const key = this.dataset.sectionId;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const image = this.querySelector('img');
        if (!image) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const effects = this.querySelector('.mal__effects');
        const mapping = this.querySelector('.mal__mapping');
        const content = this.querySelector('.mal__content');
        const eyebrow = this.querySelector('.mal__eyebrow');
        const button = this.querySelector('.mal__button');
        const alignClouds = () => {
          // Layout offsets exclude entrance transforms so ornaments stay still.
          for (const [row, name] of [[eyebrow, 'upper'], [button, 'lower']]) {
            if (!row) continue;
            let y = row.offsetHeight / 2;
            for (let node = row; node && node !== content; node = node.offsetParent) y += node.offsetTop;
            content.style.setProperty('--mal-cloud-' + name + '-y', y + 'px');
          }
        };
        const align = () => {
          alignClouds();
          const { width, height } = image.getBoundingClientRect();
          if (!width || !height) return;
          const fit = getComputedStyle(image).objectFit;
          let sx = width / 2764;
          let sy = height / 1504;
          if (fit === 'contain' || fit === 'cover') {
            sx = sy = fit === 'cover' ? Math.max(sx, sy) : Math.min(sx, sy);
          }
          effects.style.setProperty('--mal-unit', 1 / Math.min(sx, sy));
          effects.setAttribute('viewBox', `0 0 ${width} ${height}`);
          mapping.setAttribute('transform', `translate(${(width - 2764 * sx) / 2} ${(height - 1504 * sy) / 2}) scale(${sx} ${sy})`);
        };
        align();
        this.resizeObserver = new ResizeObserver(align);
        this.resizeObserver.observe(image);
        this.resizeObserver.observe(content);
        if (eyebrow) this.resizeObserver.observe(eyebrow);
        if (button) this.resizeObserver.observe(button);
        let ready = false;
        let visible = false;
        let started = played.has(key);
        if (motion.matches) this.restoreHeading();
        else if (!started) this.prepareHeading(key);
        const finish = () => {
          clearTimeout(this.settleTimer);
          this.classList.remove('is-pending', 'is-playing', 'is-resting');
        };
        const schedule = () => {
          clearTimeout(this.settleTimer);
          const onScreen = visible && !document.hidden;
          this.classList.toggle('is-offscreen', !onScreen);
          if (started || !ready || !onScreen || motion.matches) return;
          this.settleTimer = setTimeout(() => {
            if (signal.aborted || !this.isConnected || motion.matches) return;
            started = true;
            played.add(key);
            this.classList.remove('is-pending');
            this.classList.add('is-playing');
          }, 300);
        };
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          schedule();
        }, { threshold: [0, 0.15] });
        this.visibilityObserver.observe(this.querySelector('.mal__visual'));
        document.addEventListener('visibilitychange', schedule, { signal });
        motion.addEventListener('change', () => {
          if (motion.matches) {
            this.restoreHeading();
            started = true;
            played.add(key);
            finish();
          }
        }, { signal });
        if (motion.matches) {
          started = true;
          played.add(key);
        } else if (started) {
          this.classList.add('is-resting');
        } else {
          this.classList.add('is-pending');
        }
        const loaded = async () => {
          if (!image.naturalWidth) { finish(); return; }
          try { await image.decode(); } catch {}
          // Finish font layout before revealing the fixed-position characters.
          if (document.fonts) await document.fonts.ready;
          if (signal.aborted) return;
          align();
          ready = true;
          schedule();
        };
        if (image.complete) loaded();
        else {
          image.addEventListener('load', loaded, { once: true, signal });
          image.addEventListener('error', finish, { once: true, signal });
        }
      }
      disconnectedCallback() {
        clearTimeout(this.settleTimer);
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.controller?.abort();
        this.classList.remove('is-pending', 'is-playing', 'is-resting', 'is-offscreen');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamami-product-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mamami-product-gallery')) {
    customElements.define('mamami-product-gallery', class extends HTMLElement {
      static locks = new Set();
      static scrollState;

      connectedCallback() {
        if (this.events) return;
        this.dialog = this.querySelector('dialog');
        this.triggers = Array.from(this.querySelectorAll('[data-gallery-trigger]'));
        if (!this.dialog || !this.triggers.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.enlarged = this.querySelector('[data-gallery-enlarged]');
        this.position = this.querySelector('[data-gallery-position]');
        this.triggers.forEach((trigger, index) => {
          trigger.addEventListener('click', () => this.open(index), options);
        });
        this.querySelector('[data-gallery-close]').addEventListener('click', () => this.close(), options);
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.showImage(this.index - 1), options);
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.showImage(this.index + 1), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.release();
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.disconnectedCallback();
        }, options);
        document.addEventListener('shopify:section:reorder', () => this.close(), options);
      }

      disconnectedCallback() {
        this.close(false);
        this.events?.abort();
        this.events = null;
      }

      showImage(index) {
        this.index = (index + this.triggers.length) % this.triggers.length;
        const trigger = this.triggers[this.index];
        const template = trigger.parentElement.querySelector('[data-gallery-image]');
        this.enlarged.replaceChildren(template.content.cloneNode(true));
        this.position.textContent = trigger.dataset.positionLabel;
      }

      open(index) {
        this.returnFocus = this.triggers[index];
        this.showImage(index);
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.lockScroll();
      }

      close(restoreFocus = true) {
        if (this.dialog?.open) this.dialog.close();
        this.release(restoreFocus);
      }

      release(restoreFocus = true) {
        this.unlockScroll();
        this.enlarged?.replaceChildren();
        if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }

      lockScroll() {
        const owner = this.constructor;
        if (owner.locks.has(this)) return;
        if (!owner.locks.size) {
          const properties = ['overflow', 'position', 'top', 'left', 'width'];
          owner.scrollState = {
            x: window.scrollX,
            y: window.scrollY,
            styles: [document.documentElement, document.body].map((element) => ({
              element,
              values: properties.map((name) => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)])
            }))
          };
          document.documentElement.style.setProperty('overflow', 'hidden');
          document.body.style.setProperty('overflow', 'hidden');
          document.body.style.setProperty('position', 'fixed');
          document.body.style.setProperty('top', `${-owner.scrollState.y}px`);
          document.body.style.setProperty('left', `${-owner.scrollState.x}px`);
          document.body.style.setProperty('width', '100%');
        }
        owner.locks.add(this);
      }

      unlockScroll() {
        const owner = this.constructor;
        if (!owner.locks.delete(this) || owner.locks.size) return;
        const state = owner.scrollState;
        state.styles.forEach(({ element, values }) => {
          values.forEach(([name, value, priority]) => {
            if (value) element.style.setProperty(name, value, priority);
            else element.style.removeProperty(name);
          });
        });
        window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
        owner.scrollState = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamami-shopee-documentary"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var play = event.target.closest('.mamami-documentary__play');
    var close = event.target.closest('.mamami-documentary__close');
    if (!play && !close) return;
    var frame = (play || close).closest('.mamami-documentary__frame');
    var playButton = frame.querySelector('.mamami-documentary__play');
    var closeButton = frame.querySelector('.mamami-documentary__close');
    if (play) {
      var id = frame.dataset.videoId;
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
      var start = parseInt(frame.dataset.start, 10) || 0;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?start=' + start + '&autoplay=1&rel=0';
      iframe.title = 'Mamami documentary on YouTube';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      playButton.hidden = true;
      frame.appendChild(iframe);
      closeButton.hidden = false;
      closeButton.focus();
    } else {
      var iframeToClose = frame.querySelector('iframe');
      if (iframeToClose) iframeToClose.remove();
      closeButton.hidden = true;
      playButton.hidden = false;
      playButton.focus();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
